import React from 'react';
import Contact from '../Components/ContactComponent/Contact';
import Header from '../Components/GlobalComponent/Header';
import Footer from '../Components/GlobalComponent/Footer';
import BannerNew from '../Components/ContactComponent/BannerNew';
import Vacancies from '../Components/VacanciesComponent/Vacancies';

const ContactPage = () => {
    return (
        <div>
            <Header/>
            <BannerNew/>
            <Contact/>
            <Footer/>
        </div>
    );
};

export default ContactPage;
